import React, { FunctionComponent } from 'react';
import { ThemeProvider } from 'styled-components/macro';
import { theme } from './theme';
import AppRouter from './AppRouter';
import { AppStateProvider } from './context/appContext';
import { KennoTenantStateProvider } from './context/kennoTenantContext';
import AppContainer from './AppContainer';
import './App.css';

const App: FunctionComponent = () => {
  return (
    <ThemeProvider theme={theme()}>
      <AppStateProvider>
        <AppContainer>
          <KennoTenantStateProvider>
            <AppRouter />
          </KennoTenantStateProvider>
        </AppContainer>
      </AppStateProvider>
    </ThemeProvider>
  );
};

export default App;
